// extracted by mini-css-extract-plugin
module.exports = {"container":"area-list_container__qxV-F","header":"area-list_header__qzeOM","title":"area-list_title__Vb6ZM","createButton":"area-list_createButton__1RmO1"};